import { ChevronsUpDown, Settings, LogOut } from 'lucide-react';
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@predoc/cow';
import { NavLink } from 'react-router';
import { useAuth } from '@/routes/AuthContext';
import { useGetCurrentUserProfile } from '@/feature/user-settings/hooks/userSettingApi';
import { NavUserSkeleton } from './NavUserSkeleton';

interface UserNavProps {
  className?: string;
  onSettingsClick?: () => void;
  enabled?: boolean;
}

export function NavUser({
  className,
  onSettingsClick,
  enabled = true,
}: UserNavProps) {
  const { setIsPopoverOpen, isPopoverOpen } = useSidebar();
  const { data: userProfile, isLoading } = useGetCurrentUserProfile({
    enabled,
  });
  const { handleSignOut } = useAuth();

  if (isLoading || !userProfile) {
    return <NavUserSkeleton className={className} />;
  }

  const name = `${userProfile.firstName} ${userProfile.lastName}`;
  const initials = `${userProfile.firstName.charAt(0)}${userProfile.lastName.charAt(0)}`;

  // Prevent the dropdown menu events for sidebar hover action
  const handleClick = (open: boolean) => {
    setIsPopoverOpen(open);
  };

  return (
    <SidebarMenu className={className}>
      <SidebarMenuItem>
        <DropdownMenu onOpenChange={handleClick}>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="w-full"
              isActive={isPopoverOpen}
            >
              <Avatar className="h-8 w-8 rounded-lg">
                {/* currently not using avatar */}
                <AvatarImage src={''} alt={name} />
                <AvatarFallback className="bg-neutral-950">
                  {initials}
                </AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold">{name}</span>
                <span className="truncate text-xs">
                  {userProfile?.emailAddress}
                </span>
              </div>
              <ChevronsUpDown className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent side="right" align="end" className="w-[200px]">
            <NavLink to="/user-settings">
              <DropdownMenuItem
                onClick={onSettingsClick}
                className="cursor-pointer"
              >
                <Settings className="size-4" />
                <span>Settings</span>
              </DropdownMenuItem>
            </NavLink>
            <DropdownMenuItem
              onClick={handleSignOut}
              className="cursor-pointer text-red-600"
            >
              <LogOut className="size-4" />
              <span>Logout</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
